"use client";

import { PDFViewer } from "@react-pdf/renderer";
import { Box } from "@chakra-ui/react";
import type { AtsJobDetails } from "./types";
import { DefaultAtsPdfDocument } from "./pdf/templates/DefaultAtsPdfDocument";
import { A4_PDF_VIEWER_HEIGHT_PX } from "./utils/a4Constants";

export interface AtsResumePdfViewerProps {
  jobDetails: AtsJobDetails;
  /** Passed to PDFViewer (default ≈ one A4 page + embedded toolbar) */
  height?: number | string;
  /** Same toolbar as https://react-pdf.org/repl — zoom / paging */
  showToolbar?: boolean;
}

/**
 * Embeds the same {@link DefaultAtsPdfDocument} used for download, so preview matches exported PDF
 * (WYSIWYG, like the react-pdf REPL).
 */
export function AtsResumePdfViewer({
  jobDetails,
  height = A4_PDF_VIEWER_HEIGHT_PX,
  showToolbar = true,
}: AtsResumePdfViewerProps) {
  return (
    <Box
      w="100%"
      maxW="100%"
      minH={`${A4_PDF_VIEWER_HEIGHT_PX}px`}
      borderRadius="md"
      overflow="hidden"
      borderWidth="1px"
      borderColor="neutral.200"
      bg="neutral.100"
      data-testid="ats-resume-pdf-preview"
    >
      <PDFViewer width="100%" height={height} showToolbar={showToolbar}>
        <DefaultAtsPdfDocument jobDetails={jobDetails} />
      </PDFViewer>
    </Box>
  );
}
